import { PropsWithChildren, ReactNode, useMemo } from 'react'
import { useAuthContext } from '../contexts/Auth/useAuthContext'
import { Role } from '../gql/graphql'

export const AdminOnly = (props: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const authContext = useAuthContext()
  const org = useMemo(() => {
    return authContext.user?.orgs.find((org) => org.id === authContext.activeOrganization)
  }, [authContext])

  const isOrgAdmin = useMemo(() => {
    if (!org) return false
    return [Role.Admin, Role.Owner].includes(org.role)
  }, [org])
  if (!isOrgAdmin) {
    if (props.fallback) {
      return <>{props.fallback}</>
    }
    return null
  }
  return <>{props.children}</>
}
